import stripTags from "striptags";

export const getArticleJson = function(article) {
  const regex = /(<([^>]+)>)/gi;
  const markup = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': article.url
        },
        headline: article.headline,
        description: article.description,
        image: article.image,
        publisher: {
          '@type': 'LocalBusiness',
          name: 'Друг для Друга',
          logo: {
            '@type': 'ImageObject',
            url: 'https://www.friendforpet.ru/images/navLogo.svg'
          }
        },
        datePublished: new Date(article.datePublished * 1000) || '',
        dateCreated: new Date(article.dateCreated * 1000) || '',
        dateModified: new Date(article.dateModified * 1000) || '',
        articleBody: article.body.replace(regex, ''),
        wordcount: article.body.replace(regex, '').split(' ').length
      }
    ]
  }
  if (article.author) {
    markup["@graph"][0]["author"] = {
      '@type': 'Person',
      name: article.author
    }
  }
  if (article.customSchema) {
    const schemaItems = JSON.parse(article.customSchema);
    markup["@graph"] = [...markup["@graph"], ...schemaItems]
  }
  return JSON.stringify(markup)
}

export const getPersonJson = function(pet) {
  const markup = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    givenName: pet.name,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://www.friendforpet.ru/pet/${pet.id}`,
      image: {
        '@type': 'ImageObject',
        url: pet.img.url,
        width: pet.img.width,
        height: pet.img.height
      },
      publisher: {
        '@type': 'Organization',
        name: 'Социальный проект Purina «Друг для Друга», здесь вы можете взять питомца из приюта',
        logo: {
          '@type': 'ImageObject',
          url: 'https://www.friendforpet.ru/images/navLogo.svg',
          width: 146,
          height: 38
        }
      },
      description: pet.description
    }
  }
  return JSON.stringify(markup)
}

export const getBreadcrumbsJson = function(list) {
  const markup = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: [{
      '@type': 'ListItem',
      position: 1,
      name: 'Главная',
      item: 'https://www.friendforpet.ru'
    }]
  }
  if (list && list.length) {
    list.forEach((item, i) => {
      const listItem = {
        '@type': 'ListItem',
        position: i + 2,
        name: item.name,
        item: `https://www.friendforpet.ru${item.link}`
      }
      markup.itemListElement.push(listItem)
    })
  }
  return JSON.stringify(markup)
}

const formatQuestions = questions =>
  questions.map(el => ({
    '@type': 'Question',
    name: el.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: stripTags(el.answer)
    }
  }))


const markupTransformMap = {
  2: arr => arr.slice(0, -2),
  3: arr => arr.slice(2)
}

export const getFAQJson = function(list) {
  const arr = list.reduce(
    (res, next, index) => [
      ...res,
      ...formatQuestions(
        markupTransformMap[index]?.(next.props.questions) ??
          next.props.questions
      )
    ],
    []
  )
  const markup = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': arr
  }
  return JSON.stringify(markup)
}
